// React
import { useState } from "react"

// Types
import type { SuccessFetch } from "types"

// Utils
import { useApi } from "utils"

// Types
interface Type {
  regency_id: number
  regency_name: string
}

export function useRegencyById(): {
  data: Type | null
  isLoading: boolean
  fetchData: (regency_id: number | string) => void
} {
  // Hooks
  const api = useApi()
  const [data, setData] = useState<Type | null>(null)
  const [isLoading, setLoading] = useState(false)

  const fetchData = (regency_id: number | string) => {
    setLoading(true)

    api.get(
      "/regencies/byid",
      { params: { regency_id } }
    ).then((res: SuccessFetch<{
      payload: Type
    }>) => {
      setData(res.data.payload)
    }).catch(() => {
      setData(null)
    }).finally(() => {
      setLoading(false)
    })
  }

  return { data, isLoading, fetchData }
}